import type { ReactNode, FC } from 'react';

import styles from '../SectionHeader.module.css';

const SectionHeaderRight: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className={styles.headerRight}>
      {children}
    </div>
  );
};

export default SectionHeaderRight;